import React, { useState } from 'react';

// STUB: REPLACE THIS WITH YOUR ACTUAL FORMSPREE FORM ID
const FORMSPREE_ID = 'YOUR_FORM_ID_HERE';

export default function ContactForm() {
    const [form, setForm] = useState({ name: '', email: '', message: '' });

    function handleChange(e) {
        setForm({ ...form, [e.target.name]: e.target.value });
    }

    return (
        <section className="contact-section py-5">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <h2 className="text-center">Write To Us </h2>

                        <form
                            action={`https://formspree.io/f/mjknjolk`}
                            method="POST"
                            className="contact-form-card"
                        >
                            <div className="mb-3">
                                <label className="form-label">Name</label>
                                <input
                                    name="name"
                                    value={form.name}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                    placeholder="Your full name"
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Email</label>
                                <input
                                    name="email"
                                    type="email"
                                    value={form.email}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                    placeholder="name@example.com"
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Message</label>
                                <textarea
                                    name="message"
                                    rows="4"
                                    value={form.message}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                    placeholder="How can we help you?"
                                ></textarea>
                            </div>

                            <div className="text-center mt-4">
                                <button type="submit" className="btn btn-nada">
                                    Send Message
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}